import React, { Suspense, Fragment, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SidebarLayout from "./Layout/SidebarLayout";
import Authenticated from "./Guard/Authenticated";
import Guest from "./Guard/Guest";
import GuestMember from "./Guard/GuestMember";
import MemberAuth from "./Guard/MemberAuth";
import BaseLayout from "./Layout/BaseLayout";
import BaseLayouts from "./Layout/Website/BaseLayouts";
import MemberLayout from "./Layout/Website/MemberLayout";
import { Fallback } from "./Layout/Fallback";

export function RenderRout() {
  return (
    <>
      <Router>
        <Suspense fallback={<Fallback />}>
          <Routes>
            {routes?.map((route, i) => {
              const Guard = route?.guard || Fragment;
              const Auth = route?.auth || Fragment;
              const Layout = route?.layout || Fragment;
              const Component = route?.element;
              return (
                <Route
                  key={i}
                  path={route.path}
                  exact={route.exact}
                  element={
                    <Guard>
                      <Auth>
                        <Layout>
                          <Component />
                        </Layout>
                      </Auth>
                    </Guard>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

const routes = [
  // Auth Pages
  {
    layout: GuestMember,
    exact: true,
    path: "/",
    element: lazy(() => import("./Component/Pages/Website/Home/Index")),
  },

  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/admin/login",
    element: lazy(() => import("./Component/Pages/Auth/Login")),
  },
  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/admin/forgot-password",
    element: lazy(() => import("./Component/Pages/Auth/ForgotPassword")),
  },
  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/admin/reset-password",
    element: lazy(() => import("./Component/Pages/Auth/ResetPassword")),
  },


  //Dashboard Pages
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/dashboard",
    element: lazy(() => import("./Component/Pages/Admin/Dasboards/Index")),
  },


  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/subadmin",
    element: lazy(() => import("./Component/Pages/Admin/Adminusers/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/member",
    element: lazy(() => import("./Component/Pages/Admin/MemberManagement/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/enquiries",
    element: lazy(() => import("./Component/Pages/Admin/GGCEnquiries/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/chnage-password",
    element: lazy(() => import("./Component/Pages/Admin/Profile/ChangePassword")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/profile",
    element: lazy(() => import("./Component/Pages/Admin/Profile/UpdateProfile")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/templates",
    element: lazy(() => import("./Component/Pages/Admin/ManageTemplates/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/fishery-management",
    element: lazy(() => import("./Component/Pages/Admin/FisheryManagement/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/catch-return",
    element: lazy(() => import("./Component/Pages/Admin/CatchReturns/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/rules-and-regulations",
    element: lazy(() => import("./Component/Pages/Admin/RulesRegulations/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/annual-Competitions",
    element: lazy(() => import("./Component/Pages/Admin/Competitions/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/club-archive",
    element: lazy(() => import("./Component/Pages/Admin/ClubArchive/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/news-letter",
    element: lazy(() => import("./Component/Pages/Admin/Newsletter/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/admin/quick-message",
    element: lazy(() => import("./Component/Pages/Admin/QuickMessage/Index")),
  },

  ///404 Page

  {
    layout: BaseLayout,
    exact: true,
    path: "*",
    element: lazy(() => import("./Component/PageNotFound")),
  },


  {
    // guard: GuestMember,
    layout: BaseLayout,
    exact: true,
    path: "/login",
    element: lazy(() => import("./Component/Pages/Website/Auth/Login")),
  },
  {
    // guard: GuestMember,
    layout: BaseLayout,
    exact: true,
    path: "/terms-and-conditions",
    element: lazy(() => import("./Component/Pages/Website/Auth/TermsAndGdpr")),
  },
  {
    layout: BaseLayout,
    exact: true,
    path: "/contact-us",
    element: lazy(() => import("./Component/Pages/Website/Enquries/ContactUs")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/member/dashboard",
    element: lazy(() => import("./Component/Pages/Website/Dashboard/MemberDashboard")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/member/catch-return",
    element: lazy(() => import("./Component/Pages/Website/CatchReturn/Index")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/maps-parking-info",
    element: lazy(() => import("./Component/Pages/Website/MapParking/MapsParkingInfo")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/report-an-incident",
    element: lazy(() => import("./Component/Pages/Website/ReportAnIncident/ReportAnIncident")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/rules-regulations",
    element: lazy(() => import("./Component/Pages/Website/RulesRegulations/RulesRegulations")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/competitions-dinners",
    element: lazy(() => import("./Component/Pages/Website/CompetitionsDinners/CompetitionsDinners")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/river-levels-weather",
    element: lazy(() => import("./Component/Pages/Website/RiverLevelsWeather/RiverLevelsWeather")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/vehicle-check",
    element: lazy(() => import("./Component/Pages/Website/VehicleCheck/VehicleCheck")),
  },
  {
    guard: MemberAuth,
    layout: MemberLayout,
    exact: true,
    path: "/check-member-info",
    element: lazy(() => import("./Component/Pages/Website/CheckMemberInfo/CheckMemberInfo")),
  },
];


